import { Attr, BelongsTo, Model } from "spraypaint";

import Organisation from "shared/resources/Organisation";
import User from "shared/resources/User";
import { ApplicationRecord } from "shared/services/spraypaint";

import AIFeatureConfiguration from "./AIFeatureConfiguration";

@Model()
class AIFeedback extends ApplicationRecord {
  static apiNamespace = "/ai";

  static jsonapiType = "feedbacks";

  @BelongsTo() user: User;

  @BelongsTo() organisation: Organisation;

  @BelongsTo() aiFeatureConfiguration: AIFeatureConfiguration;

  @Attr() source: string;

  @Attr() input: Record<string, unknown>;

  @Attr() generatedResult: Record<string, unknown>;

  @Attr() thumbsUp: string;

  @Attr() thumbsDownReason: string;

  @Attr() aiFeatureConfigurationId: number;

  @Attr() archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default AIFeedback;
